import axios from 'axios'

//const url = 'https://script.google.com/macros/s/AKfycbzenI6CVgwrztiDNS48S6blCTzvXJC0am_2LPx0kWr3I8yADP5jOMLvS8_O6wbVjg29/exec';
const url =
  'https://script.google.com/macros/s/AKfycbxIN060OJiMFQUEb-8ZMP-NPaChVBQ3q21yvr7PceQw1DRTRjb_hm5XNRcgRSt5Z9cT/exec'
//const url = 'https://script.google.com/macros/s/AKfycbxX7lsf8G7jimBJMcLNQl-Txk0Bm5LesxNCNcmPDk9gk-9lrtJtQYzA26WaalL67bqY/exec'; //added google_address field gives cors error....

/**
 * Fetch from google climatic webapp api
 * @param addressStr the complete address in streetaddress, city, province format
 * @return {Object} The json {lat, lon}
 */
async function fetchGPS(addressStr: String) {
  let gps
  await axios
    .get(url, {
      params: {
        function: 'lookupGPS',
        address: addressStr
      }
    })
    .then(function (response) {
      gps = response.data.payload
      console.log(response)
    })
    .catch(function (error) {
      console.log(error)
      //gps={'lat': -99, 'lon': -100};
      throw new Error("error fetching gpslookup from google custom api");
    })
  return gps
}

/**
 * Fetch from google climatic webapp api
 * @param gpsStr {String} The csv 'lat, lon'
 * @return {Object} The nearest climatic site data in json
 */
async function fetchNearestSite(gpsStr: String) {
  let siteData
  await axios
    .get(url, {
      params: {
        function: 'lookupClosestClimaticSite',
        address: gpsStr
      }
    })
    .then(function (response) {
      siteData = response.data.payload
      console.log(response)
    })
    .catch(function (error) {
      console.log(error)
    })
  return siteData
}

export { fetchGPS, fetchNearestSite }
